/** tags — EN source. */
export const tags = {
  // --- Profile tags ---
  tag_90s_kid: "90s Kid",
  tag_restaurants: "Restaurants",
  tag_music: "Music",
  tag_self_care: "Self Care",
  tag_concerts: "Concerts",
  tag_house_parties: "House Parties",
  tag_drinks: "Drinks",
  tag_athletics: "Athletics",
  tag_religious: "Religious",
  tag_sports: "Sports",
  tag_meditation: "Meditation",
  tag_night_life: "Night Life",
  tag_books: "Books",
  tag_cafes: "Cafes",
  tag_raves: "Raves",
  tag_clubs: "Clubs",
  tag_traveling: "Traveling",
  tag_business: "Business",
  tag_sneakers: "Sneakers",
  tag_instagram: "Instagram",
  tag_nature: "Nature",
  tag_introvert: "Introvert",
  tag_extrovert: "Extrovert",
  tag_minimalist: "Minimalist",
  tag_astrology: "Astrology",
  tag_fashion: "Fashion",
  tag_tattoos: "Tattoos",
  tag_thrifting: "Thrifting",
  tag_plant_parent: "Plant Parent",
  tag_dog_lover: "Dog Lover",
  tag_cat_lover: "Cat Lover",
  tag_volunteering: "Volunteering",
  tag_sustainability: "Sustainability",
  tag_skincare: "Skincare",
  tag_journaling: "Journaling",
  tag_spirituality: "Spirituality",
  tag_vintage: "Vintage",
  tag_diy: "DIY",
  tag_entrepreneurship: "Entrepreneurship",
  tag_side_hustles: "Side Hustles",
  tag_cooking: "Cooking",
  tag_baking: "Baking",
  tag_coffee: "Coffee",
  tag_wine: "Wine",
  tag_craft_beer: "Craft Beer",
  tag_cocktails: "Cocktails",
  tag_vegan: "Vegan",
  tag_foodie: "Foodie",
  tag_brunch: "Brunch",
  tag_street_food: "Street Food",
  tag_sushi: "Sushi",
  tag_bbq: "BBQ",
  tag_tea: "Tea",
  tag_photography: "Photography",
  tag_art: "Art",
  tag_museums: "Museums",
  tag_theater: "Theater",
  tag_poetry: "Poetry",
  tag_film: "Film",
  tag_anime: "Anime",
  tag_k_pop: "K-Pop",
  tag_hip_hop: "Hip Hop",
  tag_jazz: "Jazz",
  tag_edm: "EDM",
  tag_r_b: "R&B",
  tag_podcasts: "Podcasts",
  tag_stand_up_comedy: "Stand-Up Comedy",
  tag_dancing: "Dancing",
  tag_writing: "Writing",
  tag_design: "Design",
  tag_gym: "Gym",
  tag_yoga: "Yoga",
  tag_running: "Running",
  tag_hiking: "Hiking",
  tag_swimming: "Swimming",
  tag_cycling: "Cycling",
  tag_climbing: "Climbing",
  tag_surfing: "Surfing",
  tag_skiing: "Skiing",
  tag_camping: "Camping",
  tag_crossfit: "CrossFit",
  tag_martial_arts: "Martial Arts",
  tag_tennis: "Tennis",
  tag_basketball: "Basketball",
  tag_soccer: "Soccer",
  tag_skateboarding: "Skateboarding",
  tag_tech: "Tech",
  tag_gaming: "Gaming",
  tag_coding: "Coding",
  tag_startups: "Startups",
  tag_investing: "Investing",
  tag_crypto: "Crypto",
  tag_ai: "AI",
  tag_science: "Science",
  tag_languages: "Languages",
  tag_psychology: "Psychology",
  tag_philosophy: "Philosophy",
  tag_history: "History",
  tag_board_games: "Board Games",
  tag_trivia: "Trivia",
  tag_karaoke: "Karaoke",
  tag_road_trips: "Road Trips",
  tag_festivals: "Festivals",
  tag_picnics: "Picnics",
  tag_beach: "Beach",
  tag_netflix: "Netflix",
  tag_true_crime: "True Crime",
  tag_memes: "Memes",
  tag_tiktok: "TikTok",
  tag_youtube: "YouTube",

  // --- Company-only tags ---
  tag_food: "Food",
  tag_concert: "Concert",
  tag_outdoor_events: "Outdoor Events",
  tag_tour: "Tour",
  tag_lounge: "Lounge",
  tag_day_night_club: "Day/Night Club",
  tag_sporting_event: "Sporting Event",
  tag_social_club: "Social Club",
  tag_sports_exercise: "Sports / Exercise",
  tag_bar: "Bar",
  tag_nightclub: "Nightclub",
  tag_cafe: "Cafe",
  tag_brewery: "Brewery",
  tag_winery: "Winery",
  tag_event_space: "Event Space",
  tag_entertainment_venue: "Entertainment Venue",
  tag_other: "Other",
  // --- Interest category section headers (#49) ---
  tag_category_popular: "Popular",
  tag_category_lifestyle: "Lifestyle & Personality",
  tag_category_food_drink: "Food & Drink",
  tag_category_arts_culture: "Arts & Culture",
  tag_category_fitness_outdoors: "Fitness & Outdoors",
  tag_category_tech_learning: "Tech & Learning",
  tag_category_social_entertainment: "Social & Entertainment",
  tag_category_other: "More",
};
